import React, { useContext } from "react";
import PropTypes from "prop-types";
import moment from "moment";

import { ViewContext } from "venuescanner-js/react/components/Inbox/context/ViewContext";

const MatchThumbnail = ({ matchEvent }) => {
  const { isMobileDevice, activeMatchEvent, setActiveMatchEvent } =
    useContext(ViewContext);

  const handleClick = () => {
    setActiveMatchEvent(matchEvent);
  };

  if (!activeMatchEvent) return null;

  return (
    <>
      <button
        className={`match-thumbnail ${
          !isMobileDevice && matchEvent._id === activeMatchEvent._id
            ? "isActive"
            : "isInactive"
        }`}
        onClick={() => handleClick()}
      >
        <span className="match-thumbnail__details p">
          {matchEvent.event_type} &#183;{" "}
          {moment(matchEvent.date_from).format("D MMM YYYY")}
        </span>
      </button>
    </>
  );
};

MatchThumbnail.propTypes = {
  matchEvent: PropTypes.object.isRequired,
};

export default MatchThumbnail;
